import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import useAjusteHorario from './useAjusteHorario';

const AjusteHorario = () => {
    
    const { loadProyecto, lstProyecto, setProyecto, proyecto, loadPuesto, puesto, lstPuesto, 
        setPuesto, fecha, handleDatechange, loadTurno, turno, lstTurno, setTurno, 
        loadEmplSus, emplSus, setEmplSus, lstEmplSus, inhabControl, procesando, empleado, setEmpleado, 
        toast,  emplesusItmSelTemplate, emplesusItemTemplate, handleClick, turnoItemTemplate, turnoValueTemplate, 
    lstEmpleados, loadEmpleado, crearDinamico, disableHoras, horaIni, setHoraIni, horaFin, setHoraFin, handleChangeCheck } = useAjusteHorario()

    const handleChangeTurno = (evt) => {
        setTurno(evt.value)
        setEmpleado(evt.value)
    }

    const handleChangeEmpleado = (evt) => {
        setEmpleado(evt.value)
    }
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    return (
        <div className="card">
            <Toast ref={toast} />
            <h5>Ajuste de Horarios</h5>
            <div className="formgrid grid p-fluid mb-3">
                {/* Proyecto */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboProyecto">Proyecto</label>
                    {loadProyecto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown id="cboProyecto" value={proyecto} onChange={(e) => setProyecto(e.value)} options={lstProyecto} placeholder="Selecciona un proyecto" optionLabel="descripcion" filter showClear />
                    )}
                </div>
                {/* Puesto */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboPuesto">Puesto</label>
                    {loadPuesto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown id="cboPuesto" value={puesto} onChange={(evt) => setPuesto(evt.value)} options={lstPuesto} placeholder="Selecccine un puesto" optionLabel="descripcion" filter showClear />
                    )}
                </div>
                {/* Fecha */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Fecha</label>
                    <Calendar value={fecha} onChange={handleDatechange} dateFormat="dd-mm-yy" minDate={hoy} showIcon/>
                </div>

                {/* Turno */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboTurno">Turno</label>
                    {loadTurno ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown id="cboTurno" value={turno} onChange={handleChangeTurno} options={lstTurno} placeholder="Seleccione un Turno" optionLabel="horarioSigla" itemTemplate={turnoItemTemplate} valueTemplate={turnoValueTemplate} filter showClear />
                    )}
                </div>

                {/*Empleado asignado */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboEmpleado">Empleado</label>
                    {loadEmpleado ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown
                            id="cboEmpleado"
                            value={empleado}
                            onChange={handleChangeEmpleado}
                            options={lstEmpleados}
                            placeholder="Seleccione un Empleado"
                            optionLabel="nombre"
                            itemTemplate={emplesusItemTemplate}
                            valueTemplate={emplesusItmSelTemplate}
                            filter showClear
                        />
                    )}
                </div>
                {/* Empleado reemplazo */}
                <div className="field col-12 md:col-6">
                    <label htmlFor="cboEmplSus">Empleado Reemplazo</label>
                    {loadEmplSus ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown
                            id="cboEmplSus"
                            value={emplSus}
                            onChange={(evt) => setEmplSus(evt.value)}
                            options={lstEmplSus}
                            placeholder="Seleccione un Empleado Sustituto"
                            optionLabel="nombre"
                            itemTemplate={emplesusItemTemplate}
                            valueTemplate={emplesusItmSelTemplate}
                            filter showClear
                        />
                    )}
                </div>
            </div>
            {/* boton */}
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-2">
                    <label>Crear con horario dinamico: </label>
                    <Checkbox checked={crearDinamico} onChange={(e) => handleChangeCheck(e)} />
                </div>
                <div className="field col-12 md:col-2">
                    <label>Hora Desde: </label>
                    <Calendar timeOnly value={horaIni} onChange={(e) => setHoraIni(e.value)} disabled={disableHoras} />
                </div>
                <div className="field col-12 md:col-2">
                    <label>Hora Desde: </label>
                    <Calendar timeOnly value={horaFin} onChange={(e) => setHoraFin(e.value)} disabled={disableHoras}/>
                </div>
                <div className="field col-12 md:col-4">
                    <span> </span>
                </div>
                <div className="field col-12 md:col-2 flex align-items-end">
                    <Button label="Guardar" onClick={handleClick} disabled={inhabControl} loading={procesando} />
                </div>
            </div>
        </div>
    );
};

export default AjusteHorario;
